import { DashboardState, ESdChangeReason, LeftPanelType, ViewPart, Visibility } from "@kuika/kuika-cl-model";
import { IWithSDProps, withSD } from "../../../shared/hoc/screen-design-consumer";
import { PureSdComponent } from "../../../shared/pure-sd";
import { LEFT_MENU_REVEAL_TARGETS } from "../../../shared/utility/use-reveal-notifications";
import KuikaButton from "../../ui-kit/kuika-button/kuika-button";
import KuikaSvg from "../../ui-kit/kuika-svg/kuika-svg";
import LeftMenuRevealIcon from "./left-menu-reveal-icon";
import { isLeftPanelButtonActive } from "./left-panel-rail";

export interface IDatasourcesButtonState {}

export interface IDatasourcesButtonProps {
  onMenuItemClick?: (panelType: LeftPanelType) => void;
}

class DatasourcesButton extends PureSdComponent<IDatasourcesButtonProps & IWithSDProps, IDatasourcesButtonState> {
  constructor(props: IDatasourcesButtonProps & IWithSDProps) {
    super(props);
    this.state = {};
  }

  handleClick = () => {
    if (this.props.onMenuItemClick) {
      this.props.onMenuItemClick(LeftPanelType.Datasources);
    } else {
      this.props.sd.setActiveLeftPanelByClick(LeftPanelType.Datasources);
    }
    this.props.sd.cancelCreatingOrEditingDatasource();
  };

  render() {
    const isWorkflowState = this.props.sd.dashboardState === DashboardState.workFlow;

    const buttonElement = (
      <LeftMenuRevealIcon targets={LEFT_MENU_REVEAL_TARGETS.datasources}>
        <KuikaButton
          data-testid="workflowDatasourceButton"
          type="tertiary"
          size="md"
          isIcon
          color="neutral"
          active={isLeftPanelButtonActive(this.props.sd, LeftPanelType.Datasources)}
          onClick={this.handleClick}
          data-onboarding-id="left_menu_custom-actions"
        >
          <KuikaSvg type="datasource-icons" name="database" width={18} height={18} pointer />
        </KuikaButton>
      </LeftMenuRevealIcon>
    );

    return <>{this.props.sd.getVisibility(ViewPart.DatasourcesButton) === Visibility.Visible && buttonElement}</>;
  }

  checkNeedRender = (changeReason: ESdChangeReason): boolean => {
    return false;
  };
}

const datasourcesButton = withSD<IDatasourcesButtonProps>(DatasourcesButton);
export { datasourcesButton as DatasourcesButton };
